import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { House } from 'lucide-react';
import SiteCredit from 'components/layout/SiteCredit';

const Container = styled.section`
  position: relative;
  display: grid;
  place-items: center;
  height: 100svh;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.yellow};
`;
const Content = styled.div`
  ${({ theme }) => theme.mixins.flexColCenter};
  gap: 2rem;

  a {
    ${({ theme }) => theme.mixins.textP1};
    ${({ theme }) => theme.mixins.flexRowCenter};
    color: ${({ theme }) => theme.colors.red};
    gap: 0.4em;
    cursor: pointer;
    text-decoration: underline;
    transition: ${(props) => props.theme.transitions.default};

    ${({ theme }) => theme.mediaQueries.sm} {
      :hover {
        color: ${({ theme }) => theme.colors.primaryDark};
      }
    }
  }
`;

const Headline = styled.h1`
  ${({ theme }) => theme.mixins.textH1};
  color: ${({ theme }) => theme.colors.red};
`;

const Credit = styled.div`
  position: absolute;
  bottom: 1.5rem;
  left: 0;
  right: 0;
  text-align: center;
  ${({ theme }) => theme.mixins.textP3};
  color: ${({ theme }) => theme.colors.red};

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

const NotFound = () => {
  return (
    <Container>
      <Content>
        <Headline>Ay no… 404!</Headline>
        <Link to="/">
          <House size="1em" />
          Return Home
        </Link>
      </Content>
      <Credit>
        <SiteCredit />
      </Credit>
    </Container>
  );
};
export default NotFound;
